define('controllers/common/page-embed.ctrl',['app'], function (app) {
    app.controller('embedPageControlller', ['$scope', 'UserInfo', '$stateParams', '$state', '$filter', '$q', '$sce',
        function ($scope, UserInfo, $stateParams, $state, $filter, $q, $sce) {
            // 初始化iframe地址
            function init() {
                var prodID = $stateParams.prodID;
                $scope.linkUrl = sysParamCfg.pmsLink + prodID ;
            }

            init();
        }]);
});
